import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const PracticeArea = styled('div')({
    paddingTop: "40px",
    paddingBottom: "40px",
    paddingLeft: "12%",
    paddingRight: "12%",
    fontSize: 30,
    fontWeight: 400,
    [MediaQuery[Size.LG]]: {
        paddingLeft: "8%",
        paddingRight: "8%",
    },
    [MediaQuery[Size.MD]]: {
        paddingLeft: "6%",
        paddingRight: "6%",
    },
    [MediaQuery[Size.SM]]: {
        paddingLeft: "4%",
        paddingRight: "4%",
    },
});

export const PracticeAreaTitle = styled('div')({
    fontWeight: 400,
    marginBottom: "22px",
    textRendering: "optimizeLegibility",
});

export const PracticeAreaInTheseAreas = styled('span')({
    color: "#CCA25E"
});

export const PracticeAreaBody = styled('div')({
    display: "flex",
    flexDirection: "column",
    fontFamily: "Gotham",
});

export const FirstCardContainer = styled('div')(({
    width
}) => ({
    width: width,
    display: "flex",
    flexDirection: "row",
    [MediaQuery[Size.LG]]: {
        width: "100%",
    },
}));

export const SecondCardContainer = styled('div')(({
    width
}) => ({
    width: width,
    marginLeft: "2%",
    color: "#E6BD73",

    [MediaQuery[Size.LG]]: {
        marginTop: "20px",
        marginLeft: "0%",
        width: "100%",
    },
}));

export const Card = styled('div')(({ 
    bgColor,
    color
 }) => ({
    background: bgColor,
    borderRadius: "22px",
    paddingTop: "40px",
    paddingBottom: "20px",
    paddingLeft: "36px",
    paddingRight: "18px",
    color: color,
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    
    fontFamily: "Gotham",
    height: "100%",
    [MediaQuery[Size.LG]]: {
        height: "auto",
        paddingTop: "36px",
        paddingLeft: "36px",
        paddingRight: "0px",
    },
    [MediaQuery[Size.MD]]: {
        paddingTop: "24px",
        paddingLeft: "36px",
    },
    [MediaQuery[Size.SM]]: {
        height: "auto",
        paddingTop: "20px",
        paddingLeft: "18px",
        paddingRight: "18px",
        width: "100%",
    }
}));

export const CardTitle = styled('div')({
    fontSize: "24px",
    fontWeight: "400",
    lineHeight: "24px"
});

export const ArrowBox = styled('div')({
    display: "flex"
})

export const CardDescription = styled('div')({
    fontSize: "14px",
    fontWeight: "400",
    marginTop: "12px"
})

export const PracticeAreaBodyFirstRow = styled('div')({
    display: "flex",
    flexDirection: "row",

    [MediaQuery[Size.LG]]: {
        display: "flex",
        flexDirection: "column",
    },
})

export const PracticeAreaBodySecondRow = styled('div')({
    display: "flex",
    flexDirection: "row",
    marginTop: "20px",
    height: "auto",

    [MediaQuery[Size.LG]]: {
        display: "flex",
        flexDirection: "column",
    },
})

export const FirstCardBodyFirstRow = styled('div')({
    width: "60%",
    marginRight: "1%",
})

export const MiniFirstImage = styled('img')({
    width: "32%",
    height: "auto",
})

export const MiniSecondImage = styled('img')({
    width: "30%",
    height: "auto",
})

export const MiniThirdImage = styled('img')({
    width: "26%",
    height: "auto",
})

export const MiniForthImage = styled('img')({
    width: "30%",
    height: "auto",
})

export const FirstImage = styled('img')({
    width: "109px",
    height: "auto",
    margin: "auto",
    [MediaQuery[Size.LG]]: {
        maxWidth: "60%",
    },
    
    [MediaQuery[Size.MD]]: {
        width: "80%",
    },
    [MediaQuery[Size.SM]]: {
        width: "90%",
    },
})

export const SecondImage = styled('img')({
    width: "160px",
    height: "auto",
    margin: "auto",
    [MediaQuery[Size.XL]]: {
        width: "100%",
    },
    [MediaQuery[Size.LG]]: {
        maxWidth: "140px",
    },
    [MediaQuery[Size.MD]]: {
        width: "80%",
    },
    [MediaQuery[Size.SM]]: {
        width: "90%",
    },
})

export const ThirdImage = styled('img')({
    width: "117px",
    height: "auto",
    margin: "auto",
    [MediaQuery[Size.XL]]: {
        width: "100%",
    },
    [MediaQuery[Size.LG]]: {
        maxWidth: "60%",
    },
    [MediaQuery[Size.MD]]: {
        width: "80%",
    },
    [MediaQuery[Size.SM]]: {
        width: "90%",
    },
})

export const ForthImage = styled('img')({
    width: "128px",
    height: "auto",
    margin: "auto",
    display: "inline-block",
    [MediaQuery[Size.XL]]: {
        width: "100%",
    },
    [MediaQuery[Size.LG]]: {
        maxWidth: "60%",
    },
    [MediaQuery[Size.NAV]]: {
        width: "70%",
    },
    [MediaQuery[Size.MD]]: {
        width: "80%",
    },
    [MediaQuery[Size.SM]]: {
        width: "90%",
    },
})

export const Circle = styled('div')({
    height: "30px",
    width: "30px",
    backgroundColor: "#CCA25E",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    float: "right",
    bottom: "20px"
})

export const Arrow = styled('img')({
    width: "16px",
    height: "16px"
})

export const SecondCardFirstRow = styled('div')({
    width: "67.5%",
    marginRight: "2.5%",
    [MediaQuery[Size.XL]]: {
        marginRight: "8.5%",
    },
    [MediaQuery[Size.LG]]: {
        marginRight: "4.5%",
    },
    
})

export const ForthCardFirstRow = styled('div')({
    width: "65%",
    marginRight: "10.5%",
    display: "flex",
    flexDirection: "column",
    [MediaQuery[Size.XL]]: {
        marginRight: "0.5%",
    }
})

export const Test = styled('div')({
    position: "fixed",
    bottom: "0px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    paddingRight: "16px",
    
})